import { createFileRoute } from '@tanstack/react-router'
import { CaseDetails } from 'pages/cases/CaseDetails'
import { z } from 'zod'

const parseParams = z.object({
  siteID: z.string(),
  caseID: z.string(),
})

export const Route = createFileRoute('/cases/$siteID/$caseID')({
  component: CaseDetails,
  params: {
    parse: parseParams.parse,
  },
  staticData: {
    title: 'Case Details',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
